import classNames from 'classnames';
import React, {
  Component, useEffect, useRef, useState,
} from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import TextInput from './TextInput';
import Dropdown from '../../base/Dropdown/Dropdown';
import { errorNotification } from '../../../modules/Notifications/notificationDecorator';
import { getResponseError } from '../../../utils/utils';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import CheckBoxInputWithLabel from '../CheckBoxInput/CheckBoxInputWithLabel';

export default function TextInputWithSelect(props) {
  const { formatMessage } = useIntl();
  const {
    disabled = false,
    withLabel = false,
    input,
    label,
    placeholder = '',
    className = '',
    meta,
    readOnly = false,
    dtoObject,
    inputProps = {},
    variant,
    onChangeInput = () => {},
    onSelect = () => {},
    renderOption = null,
    // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
    // nosemgrep
    controlId = `text-input-${Math.random() * 10000}`,
    formMeta,
    loadAction,
    filterName = 'search',
    optionFormatter = null,
    additionalFilter = {},
    inputAfter = null,
  } = props;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const anchorElement = useRef(null);
  const { onFocus = () => {}, onChange = () => {}, name = '' } = inputProps;

  const defaultValue = '';
  const value = inputProps && (typeof inputProps.value !== 'undefined') ? inputProps.value : defaultValue;

  const defaultRenderOption = item => (!item.name && item.nameId ? formatMessage({ id: item.nameId }) : item.name || '');
  let renderOptionFunction = defaultRenderOption;
  if (renderOption && typeof renderOption === 'function') {
    renderOptionFunction = renderOption;
  }

  const handleFocus = event => {
    onFocus(event);
    toggleOpen(true);
  };
  const toggleOpen = open => {
    if (disabled) {
      return;
    }
    setOpen(open);
  };
  const handleClose = () => setOpen(false);
  const handleInputChange = event => {
    const {
      target: {
        value,
      },
    } = event;
    if (!open) {
      toggleOpen(true);
    }
    onChange({ target: { value, name } });
    onChangeInput(value);
    loadOptions(value);
    onSelect(null);
  };
  const handleSelect = item => {
    handleClose();
    onSelect(item);
    onChange({ target: { value: item.name, name } });
  };
  const loadOptions = (value = '') => {
    const defaultOptionFormatter = item => ({ value: item.id, name: item.number });
    dispatch(loadAction({ filter: { [filterName]: value, ...additionalFilter } }))
      .then(data => {
        if (!data?.data) { return; }
        setOptions((data?.data || []).map(optionFormatter || defaultOptionFormatter));
      })
      .catch(response => errorNotification('Загрузка данных', getResponseError(response)));
  };

  useEffect(() => {
    if (typeof loadAction === 'function') {
      loadOptions();
    }
  }, []);
  const [toggleFunction, setToggleFunction] = useState(() => () => {});
  return (
    <div className={classNames('form-control-wrapper', className)}>
      <Dropdown
        usePortal
        disabled={disabled}
        setToggleFunction={a => setToggleFunction(() => a)}
      >
        <Dropdown.Toggle
          className="multiple-select-toggle"
        >
          <TextInput
            label={label}
            withLabel={withLabel}
            readOnly={readOnly}
            inputProps={{
              ...inputProps,
              onChange: handleInputChange,
              onFocus: handleFocus,
              // onBlur: handleClose,
            }}
            placeholder={placeholder}
            meta={meta}
            dtoObject={dtoObject}
            disabled={disabled}
            variant={variant}
            containerRef={anchorElement}
            formMeta={formMeta}
            inputAfter={(
              <div id={controlId} className="select-arrow-wrapper">
                {inputAfter}
                <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
              </div>
            )}
          />
        </Dropdown.Toggle>
        <Dropdown.Menu
          useResizeContent={false}
          disableClickToggle={false}
          rightPadding={32}
          className="select-options-wrapper"
          anchorElement={anchorElement}
          classNamePortal={classNames('portal-select-options')}
        >
          <div className="select-options-list">
            {options.map((item, key) => {
              const isSelected = item.value === value;
              return (
                <div
                  key={key}
                  className={classNames('select-option', { selected: isSelected })}
                  onClick={() => {
                    handleSelect(item);
                  }}
                >
                  <CheckBoxInputWithLabel
                    inputProps={{
                      value: isSelected,
                      onChange: () => {},
                    }}
                    label={renderOptionFunction(item)}
                  />
                </div>
              );
            })}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
